import React from 'react';
import getConfig from 'next/config';

import LazyLoadImage from 'components/LazyLoad/Image';
import SubscribeForm from 'containers/forms/SubscribeForm';

import styles from './styles.module.scss';

const {
	publicRuntimeConfig: { basePath }
} = getConfig();

const SubscribeBlock = () => {
	const imageSrc = `${basePath}/images/live/subscribe_promo.jpg`;
	return (
		<div className={styles.promo}>
			<LazyLoadImage className={styles.imageWrapper} imageSrc={imageSrc}>
				<div
					className={styles.image}
					style={{ backgroundImage: `url(${imageSrc})` }}
				/>
			</LazyLoadImage>
			<div className={styles.content}>
				<div className={styles.heading}>
					<div className={styles.title}>Еженедельная рассылка</div>
					<div className={styles.description}>
						Лучшие статьи, тесты и спецпроекты, увлекательные подборки кино,
						спектаклей и лекций &mdash; каждую пятницу
					</div>
				</div>
				<div className={styles.form}>
					<SubscribeForm id="subscribe-block" theme="air" />
				</div>
			</div>
		</div>
	);
};

export default SubscribeBlock;
